export function getAllButLastWord(words) {
  if (words && words.length > 0) {
    const lastIndex = words.lastIndexOf(" ")
    return words.substring(0, lastIndex) + " "
  }
}
